import { templateLicenseFratSubForm } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { LicenseFratSubFormWebComponent } from '../component/LicenseFratSubFormWebComponent';
import { LicenseFratSubFormView } from '../view/LicenseFratSubFormView';

export class LicenseFratSubFormController extends BaseWebComponentController {
  public component: LicenseFratSubFormWebComponent;
  public view: LicenseFratSubFormView;
  public viewConstructor: typeof LicenseFratSubFormView;

  constructor(component: LicenseFratSubFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: LicenseFratSubFormView,
      viewTemplate: templateLicenseFratSubForm,
    });
  }
}
